import { Link, classNames } from '@/core'
import { IconButton } from '@c/icon-button'
import { doc } from './doc'
import styles from './style.module.styl'

export const AdminMenu = doc(({ onClickMenu, className }) => {
  return (
    <div className={classNames(styles.adminMenu, className)}>
      <div className={styles.adminMenuHeader}>
        <h3>Admin</h3>
        <IconButton icon="Menu" />
      </div>
      <Link name="adminOpportunities">Opportunities</Link>
      <Link name="adminMetrics">Metrics</Link>
    </div>
  )
})
